// Promoção de "Valor fixo": o número digitado é o PREÇO FINAL que o cliente paga,
// não um desconto (pedido do dono, 27/10/2026). Por isso o campo vem escrito
// "De R$ 12,00 por R$ ___" e digita da direita pra esquerda, como caixa
// registradora (1 → 0,01 · 990 → 9,90), igual aos outros campos de dinheiro.
// `value` é texto "9.9" (o formato que a promoção guarda); vazio = sem preço.
import { InputDecimal } from "@/components/ui/input-decimal";

const reais = (n) => `R$ ${Number(n || 0).toFixed(2).replace(".", ",")}`;

export default function PrecoPor({ base, value, onChange, compacto = false }) {
  const preco = Number(value);
  const temBase = Number(base) > 0;
  const temPreco = Number.isFinite(preco) && preco > 0;
  const acima = temBase && temPreco && preco >= Number(base);
  const economia = temBase && temPreco && !acima ? Number(base) - preco : 0;
  return (
    <div className="flex flex-col gap-1 min-w-0">
      <div className="flex items-center gap-1.5 flex-wrap text-xs">
        <span className="text-muted-foreground whitespace-nowrap">
          De <span className="line-through tabular-nums">{temBase ? reais(base) : "—"}</span> por
        </span>
        <div className={`relative ${compacto ? "w-24" : "w-28"}`}>
          <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-xs font-semibold text-muted-foreground pointer-events-none z-10">R$</span>
          <InputDecimal decimals={2} value={value} onChange={onChange} data-e2e="promo-preco-por"
            className={`h-8 pl-8 pr-2 text-sm font-bold ${acima ? "border-red-500 text-red-600" : "text-green-600 dark:text-green-400"}`} />
        </div>
      </div>
      {acima ? (
        <p className="text-[10px] text-red-600 dark:text-red-400 font-medium">
          Precisa ser menor que {reais(base)}
        </p>
      ) : !compacto && (
        <p className="text-[10px] text-muted-foreground">
          {economia > 0
            ? <>Preço que o cliente paga · economiza <strong className="text-green-600 dark:text-green-400">{reais(economia)}</strong></>
            : "Digite o preço que o cliente vai pagar"}
        </p>
      )}
    </div>
  );
}
